import styled from 'styled-components';

import Card from 'components/insights/layout/Card';
import AccessGuard from 'components/shared/AccessGuard';
import Button from 'components/shared/Button';
import { PERMISSIONS } from 'models/Profile';
import { colors } from 'styles/theme/colors';
import { BodySmall, H3 } from 'styles/typography';
import PillIcon from 'svg/PillIcon';

export type HighCostMedsEmptyStateProps = {
  onAdd: () => void;
};

export default function HighCostMedsEmptyState({ onAdd }: HighCostMedsEmptyStateProps) {
  return (
    <Container data-testid='high-cost-meds-empty-state'>
      <PillIcon width={24} height={24} style={{ color: colors.blue100 }} />
      <H3>No High Cost Meds</H3>
      <BodySmall color={colors.black100}>
        No medications have been added to your high cost medication list yet.
      </BodySmall>
      <AccessGuard accessor={PERMISSIONS.highCostMedicationListItemCreate}>
        <AddButton variant='primary' onClick={onAdd}>
          Add New Medication
        </AddButton>
      </AccessGuard>
    </Container>
  );
}

const Container = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 40px;
  text-align: center;
`;

const AddButton = styled(Button)`
  margin-top: 16px;
`;
